import axios from 'axios';

// const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const API_BASE = process.env.REACT_APP_API_URL || 'https://voice-sample.tpvai.com/api/piper';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 180000, // 3 min — model downloads can be slow
});

/* ─── TTS ─────────────────────────────────────────────────────────────────── */

/**
 * POST /api/tts/speak
 * Returns blob URL for audio playback
 */
export const synthesizeSpeech = async ({ text, lang, gender }) => {
  const response = await api.post(
    '/api/tts/speak',
    { text, lang, gender },
    { responseType: 'blob' }
  );
  const blobUrl = URL.createObjectURL(response.data);
  return {
    blobUrl,
    requestId: response.headers['x-request-id'] || '',
    processingTime: response.headers['x-processing-time-ms'] || '',
    s3Url: response.headers['x-s3-url'] || '',
  };
};

/* ─── Feedback ────────────────────────────────────────────────────────────── */

/**
 * POST /api/feedback
 */
export const submitFeedback = async (payload) => {
  const res = await api.post('/api/feedback', payload);
  return res.data;
};

export default api;
